import { useState } from 'react';

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null); // Gère quelle réponse est ouverte

    const toggleDropdown = (index) => {
        setOpenIndex(openIndex === index ? null : index); // Ouvre/ferme les réponses
    };

    //     1. 
    // 2. .
    // 3. 
    //     4. 
    // 5. 
    //     6. 
    // 7. Choisissez bien votre cup, votre vie de célibataire peut s'arrêter ici.
    //     8. Soutenez les Stands de nourriture, mangez quelque chose.
    // 9. Soutenez le Bar, mais reconnaissez vos limites.
    // 10. God Bless The Movement!



    const faqData = [
        {
            question: "Titre 1",
            answer: "Soyez Drip: exprimez votre créativité et votre personnalité.",
        },
        {
            question: "Titre 2",
            answer: "Dansez, Vibez. Rentrez chez vous safe et en bonne santé.",
        },
        {
            question: "Titre 3",
            answer: "Profitez de l'expérience. Connectez avec le Mouvement.",
        },
        {
            question: "Titre 4",
            answer: "Si vous voyez quelque chose, dites quelque chose.",
        },
        {
            question: "Titre 5",
            answer: "Respect et Courtoisie. La base des bases des bases.",
        },
        {
            question: "Titre 6",
            answer: "Partagez votre enjaillement ! Utilisez les hashtags #lafriendzone, ou #lafriendzonelome.",
        },
        {
            question: "Titre 7",
            answer: "Choisissez bien votre cup, votre vie de célibataire peut s'arrêter ici. Faites le bon choix.",
        },
        {
            question: "Titre 8",
            answer: "Soutenez les Stands de nourriture, mangez quelque chose !",
        },
        {
            question: "Titre 9",
            answer: "Soutenez le Bar, mais reconnaissez vos limites.",
        },
        {
            question: "Titre 10",
            answer: "God Bless The Movement !",
        },

        // Ajoute plus de questions ici si nécessaire
    ];

    return (
        <div className="flex flex-col w-full lg:gap-10 gap-5">
            <p className="flex flex-col lg:text-[65px] text-[16px] font-chido">GOOD TO KNOW
                <span className="font-concretica lg:text-[48px] text-[14px]">Les 10 Commandements du Mouvement.</span>
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-5">
                {faqData.map((item, index) => (
                    <div key={index} className=" lg:h-fit lg:border-[6px] border-[4px] border-offblack lg:rounded-[20px] rounded-[5px]">

                        <div className="flex justify-between items-center p-4 cursor-pointer font-chido" onClick={() => toggleDropdown(index)}>
                            <p className="lg:text-[24px] uppercase">{item.question}</p>
                            <button className="text-[24px] font-black">
                                {openIndex === index ? '-' : '+'}
                            </button>
                        </div>

                        {openIndex === index && (
                            <div className="p-4 border-t-2 font-bold font-concretica border-offblack transition-all duration-300 ease-in-out">
                                <p className='lg:text-[20px]'>{item.answer}</p>
                            </div>
                        )}

                    </div>
                ))}
            </div>

        </div>
    );
};

export default FAQ;
